module.exports = __webpack_public_path__ + "img/pro_checkbox.2b28887.png";